import Container from '@bit/ui-common.ui-components/ss-components/react/Container';
import { Modal, Button } from 'antd';
import moment from 'moment';

const styleProps = {
  titleDiv: {
    style: {
      fontSize: 12,
      fontWeight: 'bold',
      marginBottom: '10px',
    },
  },
  bodyDiv: {
    style: {
      borderColor: '#DDDDDD',
      borderStyle: 'solid',
      borderWidth: '1px',
      padding: '5px',
      minWidth: 700,
    },
  },
};

export default Container(  {
    state: (s) => ({
      commonData: s.commonData,
    }),
    services: [],
  },

  class AfspAcknowledgement extends React.Component {
    state = {
      textEntries: null,
      textHasLoaded: false,
      showAcknowledgement: null,
    };

    constructor(props) {
      super(props);
    }

    // type could be a,c,d,f,p
    loadAcknowledgmentContent() {
      const { commonData, role, description } = this.props;
      const { ACK } = commonData.textData.textDataStore;

      let fullName = '';

      if (window.session && window.session.jwtSession)
      {
        const { USER_DETAILS } = window.session.jwtSession;
        const { FIRST_NAME, LAST_NAME } = USER_DETAILS;
        fullName = `${FIRST_NAME} ${LAST_NAME}`;
      }

      if (
        ACK !== undefined &&
        role !== undefined &&
        !this.state.textHasLoaded
      ) {

        const textEntries = ACK[this.props.role];
        const filteredEntries = textEntries.filter((textEntry) => textEntry.textDescription === description)
        const sanitizedTextEntries = filteredEntries.length === 1 ? [] : new Array(filteredEntries.length).fill(null);

        for (const textEntry of filteredEntries) {
            if (textEntry.text.includes('template.candidateName')) {
              textEntry.text = textEntry.text.replaceAll(
                /\[\(\$\{template\.candidateName\}\)\]/g,
                fullName
              );
            }

            if (textEntry.text.includes('todaysDate')) {
              textEntry.text = textEntry.text.replaceAll(
                /\[\(\$\{todaysDate\}\)\]/g,
                moment().format('MM/DD/YYYY')
              );
            }


            textEntry.text = textEntry.text.replace(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/g, (match, $1) =>{
              
              return "/home/warning?url=" + match;
            });


            if (textEntry.order) {
              sanitizedTextEntries[textEntry.order - 1] = textEntry;
            } else {
              sanitizedTextEntries.push(textEntry);
            }

            
        }

        this.setState({
          textHasLoaded: true,
          textEntries: sanitizedTextEntries,
        });
      }
    }

    componentDidMount() {
      this.loadAcknowledgmentContent();
    }

    componentDidUpdate() {
      this.loadAcknowledgmentContent();
    }

    handleAccept = () => {
      try {
        this.props.onAccept();
      } catch {}
    };

    handleDeny = () => {
      try {
        this.props.onDeny();
      } catch {}
    };

    render() {
      const isVisible = this.props.showAcknowledgement === true;

      return (
        <div>
          <Modal
            footer={null}
            centered={true}
            closable={false}
            width={750}
            visible={isVisible}
            bodyStyle={{
              padding: '15px',
              overflowY: 'scroll',
              height: '400px',
            }}
            onOk={this.handleAccept}
          >
            <div>
              <div {...styleProps.titleDiv}>
                {this.props.header ? this.props.header : this.props.description}
              </div>
              <div {...styleProps.bodyDiv}>
                {this.state.textEntries &&
                  this.state.textEntries.map((textEntry) => {
                    return (
                      <div
                        key={textEntry.textDescription}
                        dangerouslySetInnerHTML={{ __html: textEntry.text }}
                      />
                    );
                  })}
              </div>
              <br />
              <Button
                size="small"
                type="default"
                onClick={this.handleAccept}
                style={{ width: '90px', marginRight: '10px' }}
              >
                {this.props.acceptText ? this.props.acceptText : 'Accept'}
              </Button>
              {this.props.denyButton && (
                <Button
                  size="small"
                  type="default"
                  onClick={this.handleDeny}
                  style={{ width: '90px', marginRight: '10px' }}
                >
                  {this.props.denyText ? this.props.denyText : 'Deny'}
                </Button>
              )}
            </div>
          </Modal>
        </div>
      );
    }
  }
);
